import { Button, Card, message } from 'antd';
import { QUOTE_STATUSES } from '../../constants/QuoteStatuses';
import { disabledByAnotherAction, recordHasContractorId } from '../../utils/DataAccessUtils';
import * as React from 'react';

export const QuoteMoveBackToDraftButton = ({
	setActionButtonLoading = () => {},
	actionButtonLoading = null,
	markDraftQuote,
	quote,
	refresh,
}) => {
	const isContractorQuote = recordHasContractorId(quote);
	const handleMarkDraftQuote = (quote) => {
		message.open({
			key: 'quoteDetailMessageUpdating',
			type: 'loading',
			content: 'Moving back to draft...',
			duration: 60,
		});
		setActionButtonLoading(QUOTE_STATUSES.draft);
		markDraftQuote(quote, isContractorQuote)
			.then((resultQuote) => {
				message.destroy('quoteDetailMessageUpdating');
				message.success('Moved back to draft!');
				refresh();
			})
			.finally(() => {
				setActionButtonLoading(null);
			});
	};

	return (
		<Button
			loading={actionButtonLoading === QUOTE_STATUSES.draft}
			disabled={disabledByAnotherAction(actionButtonLoading, QUOTE_STATUSES.draft)}
			style={{ marginRight: 12 }}
			onClick={() => {
				handleMarkDraftQuote(quote);
			}}
		>
			Move Back To Draft
		</Button>
	);
};
